// extracted by mini-css-extract-plugin
export var container = "_8q-0";
export var icon = "_8q-1";
export var text = "_8q-2";